import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface EPAHoldingQueueCount {
  isLoading: boolean;
  error: boolean;
  message?: string | null;
  EPAHoldingQueueCountData?: any;
  Items?: any;
  Pagination?: any;
}

const initialState: EPAHoldingQueueCount = {
  isLoading: false,
  error: false,
  message: null,
  EPAHoldingQueueCountData: [],
  Items: [],
  Pagination: [],
};

const EPAHoldingQueueCountSlice = createSlice({
  name: "EPAHoldingQueueCount",
  initialState,
  reducers: {
    loadingEPAHoldingQueueCount: (
      state: EPAHoldingQueueCount,
      action: PayloadAction<{}>
    ) => {
      state.isLoading = true;
    },
    setEPAHoldingQueueCount: (
      state: any,
      action: PayloadAction<EPAHoldingQueueCount>
    ) => {
      return action.payload;
    },
    clearData: (state: EPAHoldingQueueCount, action: PayloadAction) => {
      state.error = false;
    },
  },
});

export const {
  loadingEPAHoldingQueueCount,
  setEPAHoldingQueueCount,
  clearData,
} = EPAHoldingQueueCountSlice.actions;
export default EPAHoldingQueueCountSlice.reducer;
